export default "__VITE_ASSET__bda09b29__"